/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function Subscript(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'Subscript',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"m3.397 3 1.561 3.16h.067L6.603 3h2.313l-2.58 5L9 13H6.628L5.025 9.807h-.067L3.355 13H1l2.651-5-2.584-5zm6.688 10.898v-1.012l2.122-1.858q.24-.216.407-.395a1.5 1.5 0 0 0 .255-.363.9.9 0 0 0 .088-.4.77.77 0 0 0-.105-.413.7.7 0 0 0-.29-.267.9.9 0 0 0-.423-.093.9.9 0 0 0-.423.099.7.7 0 0 0-.284.281.94.94 0 0 0-.1.45H10q0-.596.267-1.026.267-.432.75-.665Q11.503 8 12.145 8q.662 0 1.15.222.489.221.756.619.27.395.27.918 0 .331-.133.659-.135.326-.48.721-.345.396-.978.946l-.696.642v.037h2.358v1.134z","fill":"currentColor"}))
}
